import Analytics from 'analytics';
import { createAnalyticsPlugin } from './plugins/pareto-analytics';
import { createRudderStackPlugin } from './plugins/rudder-stack';

export const analytics = Analytics({
    app: 'pareto-ads',
    plugins: [
        createAnalyticsPlugin({
            serviceUrl: process.env.PARETO_ANALYTICS_URL,
            appId: process.env.PARETO_ANALYTICS_APP_ID,
        }),
        createRudderStackPlugin({
            writeKey: process.env.RUDDER_STACK_WRITE_KEY,
            dataPlaneUrl: process.env.RUDDER_STACK_DATA_PLANE_URL,
        }),
    ],
});
